// extracted by mini-css-extract-plugin
module.exports = {"detailPanel":"SimpleDetails_detailPanel__2PJgc","editBtn":"SimpleDetails_editBtn__3ygtP"};